<template>
  <div
    class="subdivision__item"
    v-for="subdivision in subdivisions"
    :key="subdivision.id"
    :class="subdivision.type"
  >
    <h3>{{ subdivision.name }}</h3>
    <div class="subdivision__logos">
      <img
        v-for="logo in subdivision.imgs"
        :key="logo"
        :src="getImageTeamPath(logo)"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "subdivision-choose-item",
  props: {
    subdivisions: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getImageTeamPath(item) {
      return require(`@/assets/images/subdivision-choose/${item}.png`);
    },
  },
};
</script>

<style lang="scss" scoped>
.subdivision {
  &__item {
    min-height: 400px;
    display: flex;
    flex-direction: column;
    gap: 44px;
    justify-content: space-between;
    border: 1px solid #1c1c1c;
    padding: 25px;
    max-width: 900px;

    @media (max-width: 767px) {
      min-height: unset;
    }

    h3 {
      font-family: UAF Sans HR, serif;
      font-weight: 500;
      font-size: 22px;
      line-height: 26px;
      text-transform: uppercase;
      width: 75%;

      @media (max-width: 767px) {
        font-size: 17px;
        line-height: 27px;
      }
    }

    .big-block {
      h3 {
        font-size: 22px;
        line-height: 27px;
      }
    }
  }

  &__logos {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;

    img {
      max-width: 100px;

      @media (max-width: 767px) {
        max-width: 67px;
      }

      @media (min-width: 768px) and (max-width: 1360px) {
        max-width: 115px;
      }
    }
  }
}
</style>
